/* src/app/admin-dashboard/kunde-kort/kunde-kort-popup/kunde-kort-info-popup.css */
::ng-deep .mat-mdc-dialog-container {
  padding: 0 !important;
  border-radius: 14px;
  overflow: hidden;
}
::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 14px;
  overflow: hidden;
}
:host {
  --kk-ink: #0f172a;
  --kk-text: #334155;
  --kk-muted: #64748b;
  --kk-faint: #94a3b8;
  --kk-line: #e2e8f0;
  --kk-bg: #f8fafc;
  --kk-accent: var(--custom-color, #0369a1);
  --kk-risk: #b91c1c;
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size: 13.5px;
  color: var(--kk-text);
  background: #fff;
}
.kk-header {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 56px 12px 20px;
  background: var(--kk-accent);
  background-image:
    linear-gradient(
      135deg,
      var(--kk-accent),
      color-mix(in srgb, var(--kk-accent) 78%, black 22%));
  color: #fff;
  flex: 0 0 auto;
}
.kk-avatar {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 600;
}
.kk-identity {
  min-width: 0;
  flex: 1 1 auto;
}
.kk-name {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.kk-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  font-size: 12.5px;
  opacity: 0.88;
  margin-top: 2px;
}
.kk-close {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #fff !important;
}
.kk-kpis {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  border-bottom: 1px solid var(--kk-line);
  background: var(--kk-bg);
  flex: 0 0 auto;
}
.kk-kpi {
  display: flex;
  flex-direction: column;
  padding: 8px 20px;
  min-width: 0;
}
.kk-kpi + .kk-kpi {
  border-left: 1px solid var(--kk-line);
}
.kk-kpi-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--kk-muted);
}
.kk-kpi-value {
  font-size: 17px;
  font-weight: 600;
  color: var(--kk-ink);
  font-variant-numeric: tabular-nums;
  line-height: 1.35;
}
.kk-kpi-sub {
  font-size: 12px;
  color: var(--kk-muted);
}
.kk-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
}
.kk-side {
  flex: 0 0 340px;
  overflow-y: auto;
  border-right: 1px solid var(--kk-line);
  background: #fff;
}
.kk-main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.kk-main ::ng-deep mat-tab-group {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.kk-main ::ng-deep .mat-mdc-tab-header {
  border-bottom: 1px solid var(--kk-line);
}
.kk-main ::ng-deep .mat-mdc-tab-body-wrapper {
  flex: 1 1 auto;
  min-height: 0;
}
.kk-main ::ng-deep .mat-mdc-tab {
  min-width: 0;
  padding: 0 16px;
}
.kk-tab-count {
  margin-left: 6px;
  padding: 0 7px;
  border-radius: 999px;
  background: #e2e8f0;
  color: var(--kk-text);
  font-size: 11.5px;
  font-weight: 600;
  line-height: 18px;
}
.kk-panel {
  padding: 14px 18px;
}
.kk-panel + .kk-panel {
  border-top: 1px solid var(--kk-line);
}
.kk-panel--edit {
  background: var(--kk-bg);
}
.kk-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
  min-height: 32px;
}
.kk-panel-head h3 {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--kk-ink);
}
.kk-count {
  color: var(--kk-faint);
  font-weight: 600;
  margin-left: 4px;
}
.kk-subhead {
  margin: 14px 0 6px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--kk-muted);
}
.kk-dl {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 5px 10px;
  margin: 0;
}
.kk-dl dt {
  font-weight: 500;
  color: var(--kk-muted);
  font-size: 12.5px;
}
.kk-dl dd {
  margin: 0;
  color: var(--kk-ink);
  word-break: break-word;
}
.kk-dl a {
  color: var(--kk-accent);
  text-decoration: none;
}
.kk-dl a:hover {
  text-decoration: underline;
}
.kk-dl--tight {
  grid-template-columns: 110px minmax(0, 1fr);
  gap: 3px 10px;
}
.kk-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 10px;
}
.kk-f {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin: 0;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--kk-muted);
  min-width: 0;
}
.kk-f--full {
  grid-column: 1 / -1;
}
.kk-f .form-control,
.kk-f .custom-select,
.kk-f .input-group {
  font-weight: 400;
}
.kk-checks {
  flex-direction: column;
  gap: 0;
  font-weight: 400;
  color: var(--kk-text);
}
.kk-edit-actions {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin: 12px -18px -14px;
  padding: 10px 18px;
  background: var(--kk-bg);
  border-top: 1px solid var(--kk-line);
}
.kk-contacts {
  display: flex;
  flex-direction: column;
}
.kk-contact {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 7px 0;
}
.kk-contact + .kk-contact {
  border-top: 1px solid #f1f5f9;
}
.kk-contact-main {
  flex: 1 1 auto;
  min-width: 0;
}
.kk-contact-name {
  font-weight: 600;
  color: var(--kk-ink);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}
.kk-contact-lines {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 12px;
  font-size: 12.5px;
}
.kk-contact-lines a {
  color: var(--kk-accent);
  text-decoration: none;
}
.kk-contact .kk-row-actions {
  opacity: 0;
  transition: opacity .15s;
  display: flex;
}
.kk-contact:hover .kk-row-actions,
.kk-contact:focus-within .kk-row-actions {
  opacity: 1;
}
.kk-icon-sm.mat-mdc-icon-button {
  width: 32px;
  height: 32px;
  padding: 4px;
  --mdc-icon-button-state-layer-size: 32px;
  color: var(--kk-muted);
}
.kk-icon-sm .mat-icon {
  font-size: 19px;
  width: 19px;
  height: 19px;
}
.kk-btn-sm.mat-mdc-button-base {
  height: 30px;
  font-size: 12.5px;
  padding: 0 10px;
}
.kk-btn-sm .mat-icon,
.kk-btn-xs .mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
}
.kk-btn-xs.mat-mdc-button-base {
  height: 26px;
  font-size: 12px;
  padding: 0 6px;
}
.kk-tab {
  padding: 16px 20px 24px;
}
.kk-section + .kk-section {
  margin-top: 24px;
}
.kk-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
}
.kk-section-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--kk-ink);
  margin: 0 0 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.kk-section-head .kk-section-title {
  margin: 0;
}
.kk-hint {
  font-size: 12.5px;
  color: var(--kk-muted);
  margin: 0 0 10px;
}
.kk-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--kk-line);
  border-radius: 10px;
}
.kk-table {
  width: 100%;
  border-collapse: collapse;
}
.kk-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--kk-bg);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--kk-muted);
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid var(--kk-line);
  white-space: nowrap;
}
.kk-table td {
  padding: 7px 10px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}
.kk-table tbody tr:last-child td {
  border-bottom: 0;
}
.kk-table .num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.kk-row {
  cursor: pointer;
}
.kk-row:hover td {
  background: #f8fafc;
}
.kk-row--open td {
  background: #f1f5f9;
}
.kk-col-num {
  width: 52px;
}
.kk-col-actions {
  width: 1%;
  white-space: nowrap;
  text-align: right;
}
.kk-chevron {
  vertical-align: middle;
  color: var(--kk-faint);
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.kk-detail-row > td {
  background: #f8fafc;
  padding: 0 !important;
}
.kk-table--nested {
  background: #fff;
}
.kk-table--nested td {
  padding: 5px 10px 5px 24px;
  font-size: 12.5px;
}
.kk-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 26px;
  padding: 0 6px;
  border-radius: 7px;
  background: #e2e8f0;
  color: var(--kk-ink);
  font-weight: 700;
  font-size: 12.5px;
}
.kk-detail {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.8fr);
  gap: 4px 28px;
  padding: 12px 16px 16px 62px;
}
.kk-detail-col--wide {
  grid-column: 1 / -1;
}
.kk-detail h5 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0 6px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--kk-muted);
}
.kk-flags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.kk-flags span {
  padding: 0 7px;
  border-radius: 6px;
  font-size: 11.5px;
  background: #f1f5f9;
  color: var(--kk-faint);
  text-decoration: line-through;
}
.kk-flags span.on {
  background: #dcfce7;
  color: #166534;
  text-decoration: none;
}
.kk-plain-list {
  margin: 0;
  padding-left: 18px;
}
.kk-plain-list li {
  padding: 1px 0;
}
.kk-strong {
  font-weight: 600;
  color: var(--kk-ink);
}
.kk-small {
  font-size: 12px;
}
.kk-muted {
  color: var(--kk-muted);
}
.kk-text-risk {
  color: var(--kk-risk);
  font-weight: 600;
}
.kk-mono {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    monospace;
  font-size: 12px;
}
.kk-empty-line {
  margin: 4px 0;
  color: var(--kk-faint);
  font-size: 12.5px;
}
.kk-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.6;
  white-space: nowrap;
}
.kk-badge + .kk-badge {
  margin-left: 4px;
}
.kk-badge--cap {
  background: #eef2ff;
  color: #3730a3;
}
.kk-badge--on {
  background: #dcfce7;
  color: #166534;
}
.kk-badge--off {
  background: #f1f5f9;
  color: #475569;
}
.kk-badge--warn {
  background: #fef3c7;
  color: #92400e;
}
.kk-badge .kk-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  display: inline-block;
}
.kk-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 3px;
}
.kk-chip {
  font-size: 11px;
  padding: 0 7px;
  border-radius: 999px;
  background: #eef2ff;
  color: #3730a3;
  font-weight: 500;
  line-height: 1.7;
}
.kk-chip--risk {
  background: #fee2e2;
  color: var(--kk-risk);
}
.kk-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 24px 16px;
  text-align: center;
  color: var(--kk-faint);
  border: 1px dashed var(--kk-line);
  border-radius: 10px;
}
.kk-empty mat-icon {
  width: 28px;
  height: 28px;
  font-size: 28px;
  opacity: 0.6;
}
.kk-empty p {
  margin: 0;
  font-size: 13px;
}
.kk-add-row {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 12px;
  max-width: 640px;
}
.kk-add-row .form-control {
  flex: 1 1 auto;
}
.kk-avtale-group {
  padding: 8px 0;
}
.kk-avtale-group + .kk-avtale-group {
  border-top: 1px solid #f1f5f9;
}
.kk-avtale-sys {
  font-weight: 600;
  color: var(--kk-ink);
  margin-bottom: 2px;
}
.kk-avtale-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 2px 0;
}
.kk-avtale-row--off {
  opacity: .5;
}
.kk-avtale-desc {
  flex: 1 1 180px;
  min-width: 0;
}
.kk-avtale-amount {
  font-weight: 600;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.kk-avtale-meta {
  font-size: 12px;
  color: var(--kk-muted);
  white-space: nowrap;
}
.kk-avtale-form {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 10px;
  align-items: flex-end;
  margin-top: 6px;
  padding: 10px;
  border: 1px solid var(--kk-line);
  border-radius: 8px;
  background: #fff;
}
.kk-avtale-kind {
  flex: 0 0 130px;
}
.kk-avtale-grow {
  flex: 1 1 240px;
}
.kk-avtale-actions {
  display: flex;
  gap: 6px;
}
.kk-avtale-error {
  flex: 1 1 100%;
  color: var(--kk-risk);
  font-size: 12.5px;
}
.kk-avtale-form .kk-hint {
  flex: 1 1 100%;
  margin: 0;
}
.kk-quick-add {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 16px;
}
.kk-task {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
}
.kk-task + .kk-task {
  border-top: 1px solid #f1f5f9;
}
.kk-task-main {
  flex: 1 1 auto;
  min-width: 0;
}
.kk-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}
.kk-filter {
  border: 1px solid var(--kk-line);
  background: #fff;
  color: var(--kk-text);
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 12.5px;
  cursor: pointer;
}
.kk-filter span {
  color: var(--kk-faint);
  margin-left: 3px;
}
.kk-filter.active {
  background: var(--kk-ink);
  border-color: var(--kk-ink);
  color: #fff;
}
.kk-filter.active span {
  color: #cbd5e1;
}
.kk-filter:focus-visible {
  outline: 2px solid var(--kk-accent);
  outline-offset: 2px;
}
.kk-feed {
  display: flex;
  flex-direction: column;
}
.kk-feed-item {
  display: flex;
  gap: 10px;
  padding: 9px 0;
  align-items: flex-start;
}
.kk-feed-item + .kk-feed-item {
  border-top: 1px solid #f1f5f9;
}
.kk-feed-icon {
  color: var(--kk-faint);
  font-size: 19px;
  width: 19px;
  height: 19px;
  margin-top: 1px;
  flex-shrink: 0;
}
.kk-feed-main {
  flex: 1 1 auto;
  min-width: 0;
}
.kk-feed-head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 10px;
}
.kk-feed-text {
  white-space: pre-wrap;
  word-break: break-word;
  margin-top: 2px;
  line-height: 1.5;
}
.kk-feed-del {
  opacity: 0;
  transition: opacity .15s;
}
.kk-feed-item:hover .kk-feed-del,
.kk-feed-item:focus-within .kk-feed-del {
  opacity: 1;
}
.kk-upload {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  margin-bottom: 12px;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  background: var(--kk-bg);
  cursor: pointer;
  color: #475569;
}
.kk-upload:hover {
  border-color: var(--kk-faint);
  background: #f1f5f9;
}
.kk-attach-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 4px 0;
}
.kk-attach-item + .kk-attach-item {
  border-top: 1px solid #f1f5f9;
}
.kk-attach-item a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--kk-accent);
  text-decoration: none;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.kk-attach-item a .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.kk-parent-link {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin: 1px 0 0;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  color: #fff;
  opacity: .92;
  font-size: 12.5px;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.kk-parent-link .mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.kk-parent-link:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}
.kk-icon-xs.mat-mdc-icon-button {
  width: 22px;
  height: 22px;
  padding: 2px;
  --mdc-icon-button-state-layer-size: 22px;
  vertical-align: middle;
  color: var(--kk-faint);
}
.kk-icon-xs .mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
}
.kk-org-suggest {
  margin-top: 8px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  padding: 6px 8px;
  background: var(--kk-bg);
}
.kk-org-suggest-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 0;
}
.kk-org-suggest-text {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.kk-org-pick {
  display: flex;
  gap: 6px;
  align-items: center;
  margin-top: 8px;
}
.kk-org-pick .custom-select {
  flex: 1 1 auto;
  min-width: 0;
}
.kk-total-row td {
  background: var(--kk-bg);
  font-weight: 600;
  color: var(--kk-ink);
  border-top: 1px solid var(--kk-line);
}
.kk-lease-banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 20px;
  flex: 0 0 auto;
  background: #fef3c7;
  color: #78350f;
  border-bottom: 1px solid #fde68a;
  font-size: 13px;
}
.kk-lease-banner--ended {
  background: #fee2e2;
  color: #7f1d1d;
  border-bottom-color: #fecaca;
}
.kk-lease-banner .mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.kk-row--lease-soon td:first-child {
  box-shadow: inset 3px 0 0 #f59e0b;
}
.kk-row--lease-ended td:first-child {
  box-shadow: inset 3px 0 0 #dc2626;
}
.kk-badge--risk {
  background: #fee2e2;
  color: #b91c1c;
}
.kk-dates-form {
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
  max-width: 260px;
}
.kk-h5-gap {
  margin-top: 14px !important;
}
.kk-inv-contact {
  display: flex;
  flex-direction: column;
}
.kk-inv-contact + .kk-inv-contact {
  margin-top: 4px;
}
@media (max-width: 960px) {
  .kk-body {
    flex-direction: column;
    overflow-y: auto;
  }
  .kk-side {
    flex: 0 0 auto;
    overflow: visible;
    border-right: 0;
    border-bottom: 1px solid var(--kk-line);
  }
  .kk-main {
    flex: 0 0 auto;
  }
  .kk-kpis {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .kk-kpi:nth-child(4) {
    border-left: 0;
  }
  .kk-detail {
    grid-template-columns: 1fr;
    padding-left: 16px;
  }
}
@media (max-width: 560px) {
  .kk-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .kk-form {
    grid-template-columns: 1fr;
  }
  .kk-tab {
    padding: 12px;
  }
}
@media (hover: none) {
  .kk-contact .kk-row-actions,
  .kk-feed-del {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .kk-contact .kk-row-actions,
  .kk-feed-del {
    transition: none;
  }
}
.cb-pane {
  padding-top: 4px;
}
.cb-list {
  display: flex;
  flex-direction: column;
  max-height: 52vh;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.cb-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  background: none;
  border: 0;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
}
.cb-item:last-child {
  border-bottom: 0;
}
.cb-item:hover:not([disabled]) {
  background: #f8fafc;
}
.cb-item--here {
  cursor: default;
  opacity: .6;
}
.cb-item-main {
  flex: 1 1 auto;
  min-width: 0;
}
.cb-list .kk-empty-line {
  padding: 12px;
  margin: 0;
}
.cb-picked {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
}
.cb-warn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: -4px 0 12px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fffbeb;
  color: #92400e;
  font-size: 13px;
}
.cb-inline-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  vertical-align: -3px;
}
.cb-card {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}
.cb-chip-x {
  display: inline-flex;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  color: var(--kk-muted);
}
.cb-chip-x mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.kk-po {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}
.kk-po .mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-right: 2px;
  vertical-align: -3px;
}
.kk-po-preview {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
}
.kk-chip--warn {
  background: #fef3c7;
  color: #92400e;
}
/*# sourceMappingURL=kunde-kort-info-popup.css.map */
